import React from 'react';
import {useDispatch} from 'react-redux';
import './SupplyRedistributeButton.css';
import ModalButton from '../../Modals/ModalWindow/ModalButton/ModalButton';
import {showSupplyRedistributeConfirmModal} from '../../../redux/actions';
import {SUPPLY_COLOR} from '../../../styles/constants';

/**
 * Кнопка футера фазы снабжения: сбросить всю текущую раздачу снабжения и
 * распределить его заново руками. Само действие — за подтверждением в
 * SupplyRedistributeConfirmModal (снабжение авто-раздается при входе в фазу,
 * и случайный клик обнулял бы всю раскладку)
 */
const SupplyRedistributeButton = ({disabled}) => {
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(showSupplyRedistributeConfirmModal());
  };

  return (
    <div className={'supply-redistribute-button-container'}>
      <ModalButton
        onClick={handleClick}
        className={'supply-redistribute-button'}
        disabled={disabled}
        style={{backgroundColor: SUPPLY_COLOR}}
      >
        <h2>Заново</h2>
        <img
          className={'supply-redistribute-button_icon'}
          src={'/img/icons/supply outline.png'}
          alt={'Снабжение'}
          title={'Снять все снабжение и распределить заново'}
        />
      </ModalButton>
    </div>
  );
};

export default SupplyRedistributeButton;
